import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { SkeletonPage, Toaster } from '@/components/ui';
import { BottomNav } from './BottomNav';
import { Sidebar } from './Sidebar';

/**
 * Authenticated app frame: persistent navigation around a routed outlet.
 *
 * Route components are lazy-loaded, so the Suspense boundary lives here
 * rather than around each individual route.
 */
export function AppShell() {
  return (
    <div className="flex min-h-dvh">
      <Sidebar />

      <div className="min-w-0 flex-1">
        {/* pb-24 clears the fixed mobile bottom bar. */}
        <main className="mx-auto max-w-[1400px] px-4 pb-24 pt-6 sm:px-6 lg:pb-10">
          <Suspense fallback={<SkeletonPage label="Loading page" />}>
            <Outlet />
          </Suspense>
        </main>
      </div>

      <BottomNav />
      <Toaster />
    </div>
  );
}
